import * as giftcardService from '@/services/giftcard.service';

const state = {
    giftCardReference: null,
    giftCardEnabled: true,
    giftCardBalance: null,
    giftCardApplied: false,
    giftCardPayAmount: 0,
    giftCardProvider: null
};

const mutations = {
    setGiftCardReference(state, value) {
        state.giftCardReference = value;
    },
    setGiftCardEnabled(state, value) {
        state.giftCardEnabled = value;
    },
    setGiftCardBalance(state, value) {
        console.log('setting balance', value);
        state.giftCardBalance = value;
    },
    setGiftCardApplied(state, value) {
        state.giftCardApplied = value;
    },
    setGiftCardPayAmount(state, value) {
        state.giftCardPayAmount += value;
    },
    resetGiftCardPayAmount(state) {
        state.giftCardPayAmount = 0;
    },
    setGiftCardProvider(state, value) {
        state.giftCardProvider = value;
    }
};

const getters = {
    giftCardReference(state) {
        return state.giftCardReference;
    },
    giftCardEnabled(state) {
        return state.giftCardEnabled;
    },
    giftCardBalance(state) {
        return state.giftCardBalance;
    },
    giftCardApplied(state) {
        return state.giftCardApplied;
    },
    giftCardPayAmount(state) {
        return state.giftCardPayAmount;
    },
    giftCardProvider(state) {
        return state.giftCardProvider;
    }
};

const actions = {
    resetGiftCardStoreValues({ commit }) {
        console.log('resetting gift card');
        commit('setGiftCardReference', null);
        commit('setGiftCardEnabled', false);
        commit('setGiftCardBalance', null);
        commit('setGiftCardApplied', false);
        commit('setGiftCardProvider', null);
        commit('resetGiftCardPayAmount');
    },
    removeGiftCard({ commit, dispatch }) {
        console.log('removing gift card');
        commit('setGiftCardReference', null);
        commit('setGiftCardBalance', null);
        commit('setGiftCardApplied', false);
        commit('resetGiftCardPayAmount');
        dispatch('cart/cartTotalWithDiscount', null, { root: true });
    },
    async isGiftCardEnabled({ commit, rootState }, venueId) {
        try {
            const accountId = rootState.venue.venue.accountId;

            await giftcardService.isGiftCardEnabled(accountId, venueId);

            commit('setGiftCardEnabled', true);
        } catch (error) {
            commit('setGiftCardEnabled', true);

            if (error.response && error.response.data) {
                return error.response.data;
            }
        }
    },
    async checkGiftCardBalance({ commit }, params) {
        try {
            const { data } = await giftcardService.checkGiftCardBalance(params);

            const balance = data.balance || 0;

            console.log('setting balance', balance);

            commit('setGiftCardReference', params.giftCardCode);
            commit('setGiftCardBalance', balance);
        } catch (error) {
            console.log('error');
            commit('setGiftCardBalance', null);

            if (error.response && error.response.data) {
                return error.response.data;
            }
        }
    },
    async redeemGiftCard({ commit, dispatch }, payload) {
        try {
            await giftcardService.redeemGiftCard(payload);

            commit('setGiftCardApplied', true);
            dispatch('resetGiftCardStoreValues');
        } catch (error) {
            commit('setGiftCardApplied', false);

            if (error.response && error.response.data) {
                throw new Error(error.response.data);
            }
            dispatch('resetGiftCardStoreValues');
        }
    }
};

export default {
    namespaced: true,
    getters,
    mutations,
    state,
    actions
};
